export default {
	auth: {
		login: '/auth/login',
		pwdChange: '/auth/change-passowrd',
	},
	home: '/',
	clientNotLogin: '/client-not-login',
	dataStudio: '/report',
	quotaData: '/quotaData',
	refund: '/devoluciones',
	airlines: {
		merchantAndInstallments: '/aerolineas/codigos-de-comercio-y-cuotas',
		merchantAndInstallmentsByCarrier: '/aerolineas/codigos-de-comercio-y-cuotas/:carrierCode',
	},
	operations: {
		flightAndAncillaryTickets: '/operations/flight-and-ancillary-tickets',
		flightIssuingControl: '/operations/flight-issuing-control',
		walletAddCard: '/operations/wallet/add-card',
		cardDesk: '/operations/card-desk',
		cardDeskRules: '/operations/card-desk/rules',
		cardDeskBoard: '/operations/card-desk/board',
		cardDeskCharges: '/operations/card-desk/charges',
	},
	prechargedServices: '/precharged-services',
	prechargedServiceDetail: '/precharged-services/:id',
	activityLogList: '/activity-logs',
	quotations: {
		saleReport: '/saleReport',
		previewClient: '/proposal/:id',
		edit: '/quotations/:id',
		editOnlyFlights: '/quotations/:id/only-flights',
		new: '/quotations/new',
		newOnlyFlights: '/quotations/new-only-flights',
		list: '/quotations',
		description: '/quotation/description',
		defaultNotIncludes: '/quotation/defaultnotincludes',
	},
	flightIssueRule: {
		list: '/flight-issue-rules',
		upsert: '/flight-issue-rules/:id',
	},
	costIssuingRules: {
		list: '/cost-issuing-rules',
	},
	tools: {
		emailSignature: '/power/tools/email-signature',
	},
	salesTools: {
		root: '/sales-tools',
		documentation: '/sales-tools/documentation',
		documentationCheck: '/sales-tools/documentation-check',
		weather: '/sales-tools/weather',
		money: '/sales-tools/money',
		highlights: '/sales-tools/highlights',
		destinationSummary: '/sales-tools/destination-summary',
		events: '/sales-tools/events',
		risk: '/sales-tools/risk',
		socialProof: '/sales-tools/social-proof',
	},
	salesOrder: {
		new: '/salesorder/new',
		newFromQuotation: '/salesorder/new-from-quotation',
		importFromQuotation: '/salesorder/:id/import-from-quotation',
		list: '/salesorder/list',
		serviceList: '/saleorder-services/list',
		calendar: '/salesorder/calendar',
		edit: '/salesorder/:id',
		fromNetsuiteId: '/salesorder-from-external/:externalId',
		screen: '/salesorder-screen/:id', //todo preguntara a seba para que puso esto porque noe sta linkeado a ningun componente
		customersSyncStatus: '/salesorder-netsuite-customers-sync-status',
		salesOrderBillingStatusSyncStatus: '/salesorder-billing-status-sync-status',
		saleOrderInvoiceDetail: '/saleorder-invoice/:invoiceId/detail',
		resumeByPax: '/salesorder/:id/resume-by-pax',
	},
	passengers: {
		list: '/passengers',
		detail: '/passengers/:id',
		accountStatement: '/passengers/:id/estado-de-cuenta',
	},
	hotels: {
		search: '/hotels',
		fareCard: '/hotels/farecard',
		searchReservations: '/reservations',
	},
	agency: {
		list: '/agencies',
		new: '/agency/new',
		update: '/agency/:id/update',
	},
	user: {
		list: '/users',
		new: '/user/new',
	},
	stats: {
		package: '/stats/packages',
		automaticRoute: '/stats/routes',
		ratesList: '/stats/rates',
		ratesAdmin: '/stats/rates-admin',
	},
	payment: {
		order: '/payments/order/:id',
		orderNaranja: '/payments/viaje-naranja-order',
		orderCash: '/payments/order-cash',
		wireTransferCheck: '/payments/wiretransfers/check',
		clientTransaction: '/payments/client/transaction/:orderId',
		chargeClient: '/payments/client/charge',
		bancardCheckConfirmation: '/payments/client/transaction/bancard/check-payment/:shopProcessId',
		dLocalCheckConfirmation: '/payments/client/transaction/dlocal/check-payment/:orderId',
		atcCheckConfirmation: '/payments/client/transaction/atc/check-payment',
		thankYouTransaction: '/payments/client/thank-you',
		wompiCheckConfirmation: '/payments/client/transaction/wompi/check-payment/:reference',
		cancelTransaction: '/payments/client/cancel-payment',
	},
	transactions: {
		viajeNaranjaItauPointTransactionList: '/transactions/itaupoints',
		viajeNaranjaBancardTransactionList: '/viaje-naranja-bancard-transaction-list',
		cashTransactions: '/cash-transactions',
		list: '/transactions',
		listV2: '/transactions-v2',
		wireTransferTransactions: '/wiretransfertransactions',
		gatewayTransactionList: '/transactionsingateway/:orderTypeId/list',
		details: '/transaction/:id',
		detailsUnified: '/transaction-details/:id',
		lookup: '/transaction-lookup',
	},
	crosses: {
		list: '/transactions/crosses',
		listV2: '/crosses-v2',
	},
	authorizations: {
		list: '/transactions/authorizations',
		listV2: '/transactions/authorizations-v2',
		details: '/authorization/:id',
	},
	packageExplorer: {
		list: '/packageexplorer',
		destinationDetail: '/packageexplorer/destination',
	},
	flightExplorer: {
		list: '/flightexplorer',
		destinationDetail: '/flightexplorer/destination',
	},
	providers: {
		list: '/providers',
		detail: '/providers/:id',
		paymentCalendar: '/providers-payment-calendar',
	},
	customers: {
		list: '/customers',
	},
	branchOffices: {
		list: '/branch-offices',
		detail: '/branch-offices/:id',
	},
	sellers: {
		teamsAndGoals: '/sellers/teams-and-goals',
	},
	mcpConnector: {
		/** Quién entra al conector de datos para Claude y qué ve (solo Super Admin). */
		users: '/admin/conector-de-datos',
	},
	providerPayments: {
		list: '/provider-payments',
		bulk: '/provider-payments/bulk',
		payments: '/provider-payments/payments',
		schedule: '/provider-payments/schedule',
	},
	clientPayments: {
		list: '/customer-receipts',
	},
	invoices: {
		list: '/invoices',
	},
	product: {
		// Sección Catálogo (Paquetes — Support API)
		pulse: '/product',
		explorer: '/product/explorer',
		packageDetail: '/product/explorer/:packageId',
		packageDetailFor: (packageId: number): string => `/product/explorer/${packageId}`,
		destinations: '/product/destinations',
		priceWatch: '/product/price-watch',
		admin: '/product/admin',
	},
	productAnalytics: {
		// Sección Análisis de Producto — solo Admin/SuperAdmin
		root: '/product-analytics',
		seasonality: '/product-analytics/seasonality',
		destinations: '/product-analytics/destinations',
		mix: '/product-analytics/mix',
		airlines: '/product-analytics/airlines',
		accommodations: '/product-analytics/accommodations',
		passengers: '/product-analytics/passengers',
		pricing: '/product-analytics/pricing',
		cancellations: '/product-analytics/cancellations',
		admin: '/product-analytics/admin',
	},
	airRoutes: {
		// Sección Rutas Aéreas — precios y variaciones (Support API — /api/routes/*)
		root: '/air-routes',
	},
	salesDashboard: {
		// ── Rutas dinámicas ───────────────────────────────────────────────────
		/** Genera la ruta para el dashboard de un vendedor por su nombre. */
		seller: (sellerName: string): string => {
			const slug = sellerName
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-+|-+$/g, '');
			return `/dashboard/${slug}`;
		},
		/** Genera la ruta para el dashboard de un equipo por su nombre. */
		team: (teamName: string): string => {
			const slug = teamName
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.replace(/[^a-z0-9]+/g, '-')
				.replace(/^-+|-+$/g, '');
			return `/dashboard/equipo/${slug}`;
		},
		// ── Patrones de ruta (para <Route path=...>) ─────────────────────────
		sellerPattern: '/dashboard/:sellerSlug',
		teamPattern: '/dashboard/equipo/:teamSlug',
		admin: '/admin/crm-workflows',
	},
	corporateCards: {
		root: '/corporate-cards',
	},
	creditRules: {
		/** Gestión de condiciones de crédito de clientes corpo (admin/superadmin). */
		root: '/clientes/condiciones-de-credito',
	},
	receivables: {
		/** Salud de cartera: aging de cuentas por cobrar (admin/superadmin). */
		cartera: '/cobros/cartera',
	},
	branchCash: {
		// ── Cajas de sucursal ─────────────────────────────────────────────────
		/** Vista agrupadora (superadmin). */
		overview: '/cajas',
		/** Detalle de una caja por su branch slug (ej. "caja-centro"). */
		detail: (branchSlug: string): string => `/cajas/${branchSlug}`,
		/** Wizard de depósito para una caja. */
		deposit: (branchSlug: string): string => `/cajas/${branchSlug}/depositar`,
		/** Lista de actas de depósito. */
		deposits: '/cajas/actas',
		/** Detalle/reporte de un acta específica. */
		depositDetail: (depositId: number | string): string => `/cajas/actas/${depositId}`,
		/** Configuración de objetivos de caja chica (superadmin). */
		targets: '/cajas/objetivos',
		// ── Patrones (para <Route path=...>) ─────────────────────────────────
		detailPattern: '/cajas/:branchSlug',
		depositPattern: '/cajas/:branchSlug/depositar',
		depositDetailPattern: '/cajas/actas/:depositId',
	},
};
